import React, {useCallback, useEffect} from "react";
import {useAuth} from "../../../hooks/useAuth";
import CustomDataTable from "shared/tables/CustomDataTable";
import {APIGetStudentWorkPlans} from "../../users/api/student";
import {getTableColumns} from "./_tableColumns";
import useDataTable from "../../../hooks/useDataTable";

interface IWorkPlan {
    classroom_name: string;
    subject_name: string;
    grade_name: string;
    subcategory_name: string;
    subcategory_score: number;
    next_level: string;
    recommended_tests_no: number;
    realized_tests_no: number;
    remaining_tests_no: number;
}

const StudentWorkPlan = ({studentId}: { studentId: string }) => {
    const {user, update} = useAuth();

    const {
        loading,
        setLoading,
        tableData,
        setTableData,
        tableColumns,
        setTableColumns,
        totalRows,
        setTotalRows,
        perPage,
        setPerPage,
        page,
        query,
        submittedQuery,
        orderBy,
        order,
        handleChangePage,
        handleRequestSort,
        handleSearch,
        handleSearchChange,
        handleClearSearch,
    } = useDataTable("", "classroom_name", undefined, "");

    const mapWorkPlan = useCallback((plan: IWorkPlan) => {
        return {
            classroom_name: plan.classroom_name,
            subject_name: plan.subject_name,
            grade_name: plan.grade_name,
            subcategory_name: plan.subcategory_name,
            subcategory_score: plan.subcategory_score,
            next_level: plan.next_level ? plan.next_level : "-",
            recommended_tests_no: plan.recommended_tests_no,
            realized_tests_no: plan.realized_tests_no,
            remaining_tests_no: plan.recommended_tests_no - plan.realized_tests_no,
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        APIGetStudentWorkPlans({
            page: `?page=${page + 1}`,
            sort: orderBy,
            order: order,
            search: submittedQuery,
            student_id: studentId
        })
            .then((response) => {
                if (response.data.success) {
                    // console.log("getStudents OK", response);
                    setTableData(response.data.data.data.map((plan: any) => mapWorkPlan(plan)));
                    setTotalRows(response.data.data.total);
                    setPerPage(response.data.data.per_page);
                    setLoading(false);
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                // console.log("getStudents ERR", err);
                update("error", {show: true, code: "A001"});
            });
    }, [page, orderBy, order, submittedQuery]);

    useEffect(() => {
        const columns = getTableColumns("student", "workPlan");
        setTableColumns(columns);
    }, [user.position]);

    return (
        <CustomDataTable
            loading={loading}
            columns={tableColumns}
            rows={tableData}
            rowsPerPage={perPage}
            page={page}
            totalRows={totalRows}
            onPageChange={handleChangePage}
            handleRequestSort={handleRequestSort}
            orderBy={orderBy}
            order={order}
            hasSearch={true}
            onSearch={handleSearch}
            onChange={handleSearchChange}
            searchValue={query}
            onClearSearch={handleClearSearch}
        />
    )
}

export default StudentWorkPlan;